<template>
    <div id="app">
        <div :class="cssClasses">
            <component :is="$route.meta.layout"
                       :title="$route.name"
                       :is-x-small="screen.isXSmall"
                       :is-large="screen.isLarge">
                <div class="content">
                    <router-view></router-view>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
    import { subscribe, unsubscribe, sizes } from "./scripts/helpers";
    import { mapGetters } from "vuex";
    export default {
        name: "app",
        components: {
        },
        data() {
            return {
                screen: this.getScreenSizeInfo()
            };
        },
        computed: {
            ...mapGetters("account", ["backgroundColor"]),
            cssClasses() {
                return ["app"].concat(this.screen.cssClasses);
            }
        },
        methods: {
            screenSizeChanged() {
                this.screen = this.getScreenSizeInfo();
            },
            getScreenSizeInfo() {
                const screenSizes = sizes();

                return {
                    isXSmall: screenSizes["screen-x-small"],
                    isSmall: screenSizes["screen-small"],
                    isMedium: screenSizes["screen-medium"],
                    isLarge: screenSizes["screen-large"],
                    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
                };
            },
            setBackgroundColor() {
                document.getElementsByClassName("app")[0].style.backgroundColor = this.backgroundColor
            }
        },
        mounted() {
            subscribe(this.screenSizeChanged);
            this.setBackgroundColor();
        },
        beforeUnmount() {
            unsubscribe(this.screenSizeChanged);
        },
        watch: {
            backgroundColor() {
                this.setBackgroundColor();
            }
        }
    };
</script>

<style lang="scss">
    @import "./themes/generated/variables.base.scss";

    html,
    body {
        margin: 0px;
        min-height: 100%;
        height: 100%;
    }

    #root {
        height: 100%;
    }

    * {
        box-sizing: border-box;
    }

    .app {
        background-color: darken($base-bg, 5);
        display: flex;
        height: 100%;
        width: 100%;
    }

    .dx-popup-content {
        padding: 5px;
    }

    .dx-lookup-popup-wrapper {
        .dx-toolbar.dx-popup-title {
            display: none;
        }

        .dx-toolbar.dx-popup-bottom.dx-popup-cancel {
            padding-top: 0;
            padding-bottom: 0;

            .dx-button-content {
                padding-top: 2px;
                padding-bottom: 3px;
            }
        }

        .dx-popup-content {
            .dx-scrollable {
                height: 100%;
            }

            .dx-lookup-search-wrapper {
                padding-top: 5px;
                padding-bottom: 5px;
            }

            .dx-item.dx-list-item .dx-item-content {
                padding-top: 5px;
                padding-bottom: 5px;
            }
        }
    }

    .dx-theme-generic .dx-toolbar {
        padding-left: 20px;
        padding-right: 20px;
    }

    .dx-header-row {
        background-color: $base-accent-light;
        color: black;

        .dx-header-filter {
            color: $base-accent;
        }
    }

    .lookup-disabled-as-read-only.dx-lookup.dx-state-disabled {
        opacity: 0.81;
        border-style: solid;
        border-color: $base-border-color !important;
        cursor: text;
    }
</style>
